<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'informes' }">{{ $t("informes") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("pedidosPorRepartidores") }}</li>
                    </ol>
                </nav>
            </div>

            <CabeceraInformes @repartidorConsultado="handleRepartidorConsultado" :idBusiness="idBusiness"
                :listBusinesses="listBusinesses" :idTpv="idTpv" :listTpv="listTpv" :dateto="dateto" :datefrom="datefrom"
                id="cabecera" idWorkers="idWorkers" :conBuscadorRepartidor="true"
                :textoExtraPlaceholder="$t('buscarPorNombreDelRepartidor')" :textoExtra="$t('repartidor')"
                :nombresRepartidores="nombresRepartidores" :conTodos="true" />
            <!--:listElmExtra="nombresRepartidores" -->
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else-if="respuesta">
                <div class="col-md-12">
                    <template v-if="list.length > 0">
                        <div class="row justify-content-between div-export">

                            <div class="col-md-2 col-xs-12">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{ $t("exportarInforme") }} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong>
                                                    <i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}
                                                </strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>

                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                    <tr style="cursor: pointer;">
                                        <th v-if="ordenacionOperario === 0" @click="sortedArrayNameASC('workerName')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{
                                                    $t("nombreRepartidor")
                                                }}
                                        </th>
                                        <th v-else @click="sortedArrayNameDESC('workerName')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t("nombreRepartidor") }}
                                        </th>
                                        <th v-if="ordenarCantidad === 0"
                                            @click="sortedArrayOrderQuantityASC('cantidadDePedidos')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{
                                                    $t("cantidadDePedidos")
                                                }}
                                        </th>
                                        <th v-else @click="sortedArrayOrderQuantityDESC('cantidadDePedidos')"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{
                                                    $t("cantidadDePedidos") }}
                                        </th>
                                        <th v-if="ordenarImporte === 0" @click="sortedArrayImporteASC('amount')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{ $t("ventas") }}
                                        </th>
                                        <th v-else @click="sortedArrayImporteDESC('amount')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t("ventas") }}
                                        </th>
                                        <th v-if="ordenarEfectivo === 0" @click="sortedArrayEfectivoASC('invitations')">
                                            <i style="color: white" class="fa fa-angle-up"></i> {{ $t('efectivo') }}
                                        </th>
                                        <th v-else @click="sortedArrayEfectivoDESC('invitations')"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{ $t('efectivo') }}
                                        </th>
                                        <th v-if="ordenarTarjeta === 0" @click="sortedArrayTarjetaASC('invitations')">
                                            <i style="color: white" class="fa fa-angle-up"></i> {{ $t('tarjeta') }}
                                        </th>
                                        <th v-else @click="sortedArrayTarjetaDESC('invitations')"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{ $t('tarjeta') }}
                                        </th>
                                        <th v-if="ordenarCheque === 0" @click="sortedArrayChequeASC('invitations')">
                                            <i style="color: white" class="fa fa-angle-up"></i> {{ $t('cheque') }}
                                        </th>
                                        <th v-else @click="sortedArrayChequeDESC('invitations')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t('cheque') }}
                                        </th>
                                        <th>{{ $t("acciones") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="obj in list">
                                        <td>{{ obj.workerName }}</td>
                                        <td class="text-right">{{ obj.salesNumber }}</td>
                                        <td class="text-right">{{ obj.amount | currency }} <span
                                                class="text-primary">({{
                                                    Math.round(100 / (getTotalVentas / obj.amount) * 100) / 100 }}%)
                                            </span></td>
                                        <td class="text-right">{{ obj.amountEfectivo | currency }} <span
                                                class="text-primary"><template v-if="obj.amountEfectivo">({{
                                                    Math.round(100
                                                        / (obj.amount / obj.amountEfectivo) * 100) / 100
                                                }}%)</template><template v-else>(0%)</template> </span></td>
                                        <td class="text-right">{{ obj.amountTarjeta | currency }} <span
                                                class="text-primary"><template v-if="obj.amountTarjeta">({{
                                                    Math.round(100 /
                                                        (obj.amount / obj.amountTarjeta) * 100) / 100 }}%)
                                                </template><template v-else>(0%)</template></span></td>
                                        <td class="text-right">{{ obj.amountCheque | currency }} <span
                                                class="text-primary"><template v-if="obj.amountCheque">({{
                                                    Math.round(100 /
                                                        (obj.amount / obj.amountCheque) * 100) / 100
                                                }}%)</template><template v-else>(0%)</template></span></td>
                                        <td  align="center">

                                            <div  class="btn btn-primary btn-link">
                                                <router-link :to="{
                                                    name: 'listado-ticket-repartidor',
                                                    params: {
                                                        idRepartidor: obj.idRepartidor,
                                                        workerName: obj.workerName,
                                                        datefrom: datefrom,
                                                        dateto: dateto,
                                                        idTpv: idTpv,
                                                        idBusiness: idBusiness
                                                    }
                                                }" @click.native="getDeliveryTickets"><i 
                                                        class="fa fa-eye text-primary has-tooltip"
                                                        data-original-title="null"
                                                        v-tooltip.top-center="$i18n.t('verTicket')">
                                                    </i></router-link>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="table-success">
                                        <td><strong>{{ $t("total") }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalPedidos }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalVentas | currency }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalEfectiva | currency }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalTarjeta | currency }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalCheque | currency }}</strong></td>
                                        <td class="text-right"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </template>
                    <template v-else>
                        <div class="alert alert-danger" role="alert">
                            {{ $t("noHay") }} <strong>{{ $t('ventasPorOperarios') }}</strong> {{ $t("rangoDeFechas") }}
                        </div>
                    </template>
                </div>

            </template>
        </div>
    </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {
    DatePicker,
    Select,
    Option,
    Dropdown,
    Loading,
    DropdownItem,
    DropdownMenu,
    Button,
    Checkbox,
    CheckboxGroup,
} from "element-ui";
import Chart from 'chart.js'
import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes"
import swal from 'sweetalert2'
import moment from 'moment'
import { mapState } from 'vuex'

export default {

    created() {
        this.loading = Loading.service({ text: "Cargando..." });
        this.$store.dispatch("setNameRoute", this.$i18n.t('pedidosPorRepartidores'));
        this.getBusiness();

        if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
            this.datefrom = this.$store.getters.dateFrom;
            this.dateto = this.$store.getters.dateTo;
        }
    },
    components: {
        CabeceraInformes,
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        textoExtra: [String],
        textoExtraPlaceholder: [String],
    },
    data() {
        return {
            idWorkers: "",
            nombresRepartidores: [],
            loading: false,
            datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
            dateto: new Date().toISOString(),
            listBusinesses: [],
            idBusiness: 0,
            list: [],
            listTpv: [],
            idTpv: -1,
            dateRangeOptions1: {
                firstDayOfWeek: 1
            },

            repartidorId: null,

            ordenacionOperario: 0,
            ordenarImporte: 0,
            ordenarInvitations: 0,
            ordenarDifHora: 0,
            ordenarSueldo: 0,
            ordenarEfectivo: 0,
            ordenarTarjeta: 0,
            ordenarCheque: 0,
            ordenarCantidad: 0,
            nameTickets: "",
            listDesgloseTicket: [],


            respuesta: true,

        }
    },
    computed: {
        ...mapState(["permiso"]),


        urlExportPDF() {
            let idTpvAMandar = "";

            if (this.idTpv == -1) {
                idTpvAMandar = 0;
            } else {
                idTpvAMandar = this.idTpv;
            }

            return this.$store.getters.apiUrl + "/workers/exportPedidosRepartidor/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
        },

        urlExportExcel() {
            let idTpvAMandar = "";

            if (this.idTpv == -1) {
                idTpvAMandar = 0;
            } else {
                idTpvAMandar = this.idTpv;
            }

            return this.$store.getters.apiUrl + "/workers/exportPedidosRepartidor/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


        },

        getTotalVentas() {
            let total = 0;
            this.list.forEach(function (d) {

                total += d.amount;
            });
            return total;
        },

        getTotalPedidos() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.salesNumber
            });
            return total;
        },

        getTotalEfectiva() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.amountEfectivo;
            });
            return total;
        },

        getTotalTarjeta() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.amountTarjeta;
            });
            return total;
        },

        getTotalCheque() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.amountCheque;
            });
            return total;
        }


    },

    methods: {

        searchCabecera(query) {
            this.searchOperario(query);
        },
        cambiarExtra(elem) {
            this.idWorkers = elem;
        },
        handleRepartidorConsultado(data) {
            this.repartidorId = data.id;
            this.repartidorNombre = data.nombre;
            // Ahora puedes usar data.id y data.nombre como necesites
        },

        verTicket(repartidor) {
            this.$router.push({
                name: 'listadoticketrepartidor',
                params: { repartidorName: repartidor.workerName }
            });
        },
        cambioBusiness(idBusinessData, listTpv) {
            if (listTpv) {
                this.listTpv = listTpv;
            }


            this.loading = Loading.service({ text: "Cargando..." });
            this.idBusiness = idBusinessData;
            this.idTpv = -1;
            this.list = [];
            this.cambioTpv(this.idTpv);
        },

        emitirConsulta() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.getSalesRepartidores();
        },

        cambioTpv(idTpvData, filtrar) {

            if (idTpvData != undefined) {
                this.idTpv = idTpvData;
            }

            this.idTpv = idTpvData;
            this.emitirConsulta();
        },

        cambioHora(dates) {
            this.datefrom = dates[0]
            this.dateto = dates[1]
        },

        sortedArrayNameASC: function () {
            this.ordenacionOperario = 1;

            function compare(a, b) {
                if (a.workerName.toUpperCase() < b.workerName.toUpperCase())
                    return -1;
                if (a.workerName.toUpperCase() > b.workerName.toUpperCase())
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayOrderQuantityASC: function () {
            this.ordenarCantidad = 1;

            function compare(a, b) {
                if (a.salesNumber < b.salesNumber)
                    return -1;
                if (a.salesNumber > b.salesNumber)
                    return 1;
                return 0;
            }

            return this.list.sort(compare)
        },
        sortedArrayOrderQuantityDESC: function () {
            this.ordenarCantidad = 0;

            function compare(a, b) {
                if (a.salesNumber > b.salesNumber)
                    return -1;
                if (a.salesNumber < b.salesNumber)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayEfectivoASC: function () {
            this.ordenarEfectivo = 1;

            function compare(a, b) {
                if (a.amountEfectivo < b.amountEfectivo)
                    return -1;
                if (a.amountEfectivo > b.amountEfectivo)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayTarjetaASC: function () {
            this.ordenarTarjeta = 1;

            function compare(a, b) {
                if (a.amountTarjeta < b.amountTarjeta)
                    return -1;
                if (a.amountTarjeta > b.amountTarjeta)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayChequeASC: function () {
            this.ordenarCheque = 1;

            function compare(a, b) {
                if (a.amountCheque < b.amountCheque)
                    return -1;
                if (a.amountCheque > b.amountCheque)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayNameDESC: function () {
            this.ordenacionOperario = 0;

            function compare(a, b) {

                if (a.workerName.toUpperCase() > b.workerName.toUpperCase())
                    return -1;
                if (a.workerName.toUpperCase() < b.workerName.toUpperCase())
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayNameDESC: function () {
            this.ordenarCantidad = 0;

            function compare(a, b) {

                if (a.salesNumber > b.salesNumber)
                    return -1;
                if (a.salesNumber < b.salesNumber)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayImporteASC: function () {
            this.ordenarImporte = 1;

            function compare(a, b) {
                if (a.amount < b.amount)
                    return -1;
                if (a.amount > b.amount)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayImporteDESC: function () {
            this.ordenarImporte = 0;

            function compare(a, b) {

                if (a.amount > b.amount)
                    return -1;
                if (a.amount < b.amount)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayEfectivoDESC: function () {
            this.ordenarEfectivo = 0;

            function compare(a, b) {

                if (a.amountEfectivo > b.amountEfectivo)
                    return -1;
                if (a.amountEfectivo < b.amountEfectivo)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayTarjetaDESC: function () {
            this.ordenarTarjeta = 0;

            function compare(a, b) {

                if (a.amountTarjeta > b.amountTarjeta)
                    return -1;
                if (a.amountTarjeta < b.amountTarjeta)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayChequeDESC: function () {
            this.ordenarCheque = 0;

            function compare(a, b) {

                if (a.amountCheque > b.amountCheque)
                    return -1;
                if (a.amountCheque < b.amountCheque)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayDifHoraASC: function () {
            this.ordenarDifHora = 1;

            function compare(a, b) {
                if (a.diffHora < b.diffHora)
                    return -1;
                if (a.diffHora > b.diffHora)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayDifHoraDESC: function () {
            this.ordenarDifHora = 0;

            function compare(a, b) {

                if (a.diffHora > b.diffHora)
                    return -1;
                if (a.diffHora < b.diffHora)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArraySueldoASC: function () {
            this.ordenarSueldo = 1;

            function compare(a, b) {
                if (a.import < b.import)
                    return -1;
                if (a.import > b.import)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArraySueldoDESC: function () {
            this.ordenarSueldo = 0;

            function compare(a, b) {

                if (a.import > b.import)
                    return -1;
                if (a.import < b.import)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {

                    vm.listBusinesses = response.data.result;

                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                    } else {

                        vm.idBusiness = response.data.result[0].id;
                    }

                    vm.getTpv();

                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getTpv() {

            this.listTpv = [];

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {

                        for (let i = 0; i < response.data.result.length; i++) {

                            let printername = {
                                nameShow: response.data.result[i].nameShow,
                                id: response.data.result[i].id
                            };

                            vm.listTpv.push(printername)
                        }

                        vm.getSalesRepartidores();
                    }


                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        
        getSalesRepartidores() {
            
            // Validación de fechas
            if (!this.datefrom || !this.dateto) {
                swal({
                    title: this.$t('ups'),
                    text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                this.loading.close();
                return; // Salir de la función
            }

            let secondsDesde = moment(this.datefrom).startOf("day").unix();
            let secondsHasta = moment(this.dateto).endOf("day").unix();

            if (secondsHasta < secondsDesde) {
                swal({
                    title: this.$t('ups'),
                    text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                this.loading.close();
                return; // Salir de la función
            }

            // Validación de negocio y JWT
            if (!this.idBusiness || !this.$store.getters.jwt) {
                swal({
                    title: this.$t('ups'),
                    text: this.$t('valoresInvalidos'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                this.loading.close();
                return; // Salir de la función
            }
            
            let config = {
                params: {
                    idBusiness: this.idBusiness,
                    idTpv: this.idTpv,
                    datefrom: secondsDesde,
                    dateto: secondsHasta,
                    //repartidorId: this.repartidorId,
                    jwt: this.$store.getters.jwt,
                    desde: 1,
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            let vm = this;
            // Llamada a la API
            this.axios.get(this.$store.getters.apiUrl + "workers/getRankingDeliveryMen", config)
                .then(response => {
                    if (response.data.response) {

                        vm.list = response.data.result;

                        this.$set(this, 'nombresRepartidores', vm.list.map(worker => ({
                            id: worker.idRepartidor,
                            name: worker.workerName
                        })));
                        const repartidorEspecifico = vm.list.find(worker => worker.workerName === this.repartidorId);

                        if (repartidorEspecifico) {
                            // Si se encuentra el repartidor, reemplazamos la lista solo con este repartidor
                            vm.list = [repartidorEspecifico];
                        } else {
                            
                        }
                        vm.respuesta = true;
                    } else if (response.data.response == false && response.data.rangoMayor) {
                        swal({
                            title: "Lo sentimos",
                            text: response.data.result,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "info",
                        });
                        this.respuesta = false;
                    } else {
                        swal({
                            title: vm.$t('accesoDenegado'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        vm.respuesta = false;
                    }
                })
                .catch(error => {
                    console.error("Error de la API:", error.response ? error.response.data : error.message);
                    swal({
                        title: this.$t('error'),
                        text: error.response ? error.response.data.message : this.$t('errorConexion'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                })
                .finally(() => {
                    this.loading.close();
                });
        },
    }

}
</script>

<style scoped>
a li {
    color: #111;
}

.card {
    padding: 20px;
}

.div-export {
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Pedidos/PedidosRepartidores.vue